export default {
  fontFamily: ['Nunito Sans', 'sans-serif'],
};
